// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"308":"6b846fdd","486":"742a53b6","822":"e91d505c"}[chunkId] + ".js";
};